"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireDefault(require("react"));

var _getComponentName = _interopRequireDefault(require("react-utils/getComponentName"));

var _utils = require("./utils");

var _refObject = _interopRequireDefault(require("../utils/propTypes/refObject"));

function _default(Component) {
  var ShareScrollElementDecorator =
  /*#__PURE__*/
  function (_React$Component) {
    (0, _inherits2.default)(ShareScrollElementDecorator, _React$Component);

    function ShareScrollElementDecorator(props) {
      var _this;

      (0, _classCallCheck2.default)(this, ShareScrollElementDecorator);
      _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(ShareScrollElementDecorator).call(this, props));
      _this._defaultScrollElementRef = {
        current: null
      };
      _this.refCallback = _this.refCallback.bind((0, _assertThisInitialized2.default)(_this));
      return _this;
    }

    (0, _createClass2.default)(ShareScrollElementDecorator, [{
      key: "refCallback",
      value: function refCallback(ref) {
        if ((0, _utils.isFunctionalComponent)(Component)) return;
        if (ref) (0, _utils.copyMethods)(ref, this);
      }
    }, {
      key: "render",
      value: function render() {
        var _this$props = this.props,
            scrollElementRef = _this$props.scrollElementRef,
            rest = (0, _objectWithoutProperties2.default)(_this$props, ["scrollElementRef"]);
        return _react.default.createElement(Component, (0, _extends2.default)({}, rest, {
          scrollElementRef: scrollElementRef || this._defaultScrollElementRef,
          ref: this.refCallback
        }));
      }
    }]);
    return ShareScrollElementDecorator;
  }(_react.default.Component);

  var componentName = (0, _getComponentName.default)(Component);
  ShareScrollElementDecorator.displayName = "ShareScrollElement(" + componentName + ")";
  ShareScrollElementDecorator.propTypes = (0, _extends2.default)({}, Component.propTypes, {
    scrollElementRef: _refObject.default
  });
  ShareScrollElementDecorator.defaultProps = Component.defaultProps;
  (0, _utils.attachWrappedComponent)(ShareScrollElementDecorator, Component);
  return ShareScrollElementDecorator;
}

module.exports = exports.default;